/**
 * Event listener for click events on the document.
 *
 * @listens document:click
 * @param {Event} event - The Event object
 */
document.addEventListener('click', function (event) {
    /**
     * If the clicked element's id is 'refresh-btn',
     * it removes the 'animate' class from the element with class 'refresh-btn-icon',
     * forces a reflow, and then adds the 'animate' class back.
     */
    if (event.target.id === 'refresh-btn') {
        const refreshBtnIcon = document.querySelector('.refresh-btn-icon')
        refreshBtnIcon.classList.remove('animate')
        void refreshBtnIcon.offsetWidth
        refreshBtnIcon.classList.add('animate')
    }

    /**
     * If the clicked element's id is 'user-refresh-btn',
     * it removes the 'animate' class from the element with class 'user-refresh-btn-icon',
     * forces a reflow, and then adds the 'animate' class back.
     */
    if (event.target.id === 'user-refresh-btn') {
        const userRefreshBtnIcon = document.querySelector('.user-refresh-btn-icon')
        userRefreshBtnIcon.classList.remove('animate')
        void userRefreshBtnIcon.offsetWidth
        userRefreshBtnIcon.classList.add('animate')
    }
})
